module.exports = __webpack_public_path__ + "media/img/frontend_application/fast-enquiry-icon-e39b698bc40810a4a81f54b8e585cc61.png";